(() => {
  if (customElements.get('snv-countdown')) return;

  class SnoveraCountdown extends HTMLElement {
    static deadlines = new Map();

    connectedCallback() {
      this.hours = this.querySelector('[data-countdown-hours]');
      this.minutes = this.querySelector('[data-countdown-minutes]');
      this.seconds = this.querySelector('[data-countdown-seconds]');
      this.label = this.querySelector('[data-countdown-label]');
      this.storageKey = this.dataset.storageKey;
      if (!this.hours || !this.minutes || !this.seconds || !this.storageKey) return;

      let storedDeadline;
      try {
        storedDeadline = Number(localStorage.getItem(this.storageKey));
      } catch {
        storedDeadline = SnoveraCountdown.deadlines.get(this.storageKey);
      }

      if (Number.isFinite(storedDeadline) && storedDeadline > 0) {
        this.deadline = storedDeadline;
      } else {
        const requestedMinutes = Number(this.dataset.durationMinutes);
        const durationMinutes = Number.isFinite(requestedMinutes) && requestedMinutes > 0 ? requestedMinutes : 120;
        this.deadline = Date.now() + durationMinutes * 60 * 1000;
        try {
          localStorage.setItem(this.storageKey, String(this.deadline));
        } catch {}
      }

      SnoveraCountdown.deadlines.set(this.storageKey, this.deadline);
      this.onStorage = (event) => {
        if (event.key !== this.storageKey) return;
        const nextDeadline = Number(event.newValue);
        if (!Number.isFinite(nextDeadline) || nextDeadline <= 0) return;
        this.deadline = nextDeadline;
        SnoveraCountdown.deadlines.set(this.storageKey, nextDeadline);
        this.render();
      };
      this.onVisibility = () => this.render();
      window.addEventListener('storage', this.onStorage);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.render();
      if (this.deadline > Date.now()) this.interval = setInterval(() => this.render(), 1000);
    }

    render() {
      const remainingSeconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const hours = String(Math.floor(remainingSeconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor(remainingSeconds / 60) % 60).padStart(2, '0');
      const seconds = String(remainingSeconds % 60).padStart(2, '0');
      this.hours.textContent = hours;
      this.minutes.textContent = minutes;
      this.seconds.textContent = seconds;
      const label = remainingSeconds > 0 ? this.dataset.label : this.dataset.expiredLabel;
      if (this.label) this.label.textContent = label;
      this.setAttribute('aria-label', `${label}: ${hours}:${minutes}:${seconds}`);
      this.dataset.expired = remainingSeconds === 0 ? 'true' : 'false';
      if (remainingSeconds === 0 && this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      window.removeEventListener('storage', this.onStorage);
      document.removeEventListener('visibilitychange', this.onVisibility);
    }
  }

  customElements.define('snv-countdown', SnoveraCountdown);
})();
